const PermanentStorage = {
  setValue (key, value) {
    localStorage.setItem(key, value)
  },

  getValue (key) {
    return localStorage.getItem(key)
  }
}

export default PermanentStorage



// WEBPACK FOOTER //
// ./src/services/permanentStorage.js